import { getAppliedRoleMetrics } from 'modules/Applied_Roles/actions'
import selectorARM from 'modules/Applied_Roles/selectors'
import Dashboard from 'modules/Dashboard/index'
import { getDrivesList } from 'modules/Drives/actions'
import selectorDrive from 'modules/Drives/selectors'
import { getFunctionsList, getListOfSkills,

  getListOfCountries,
  getListOfState,
  getListOfCity,
  searchAPI,
  updateCvDetails,
  deleteEducation,
  updateCurrentState,
  updateStatusPending,
  updateUserProfile,
  getDesignationsList
 } from 'modules/Onboarding/actions'
import selector2 from 'modules/Onboarding/selectors'
import {
  getStudentData,
  updateStudent,
  updateStudentData,
} from 'modules/Resume/actions'
import {
  ApplyRole,
  SaveRole,
  getCompTypeList,
  getEligibleDetails,
  getRoleFloatDetails,
  getRolesList,
  getSingleRoleDetails,
  getStudentRoleList,
  getStudentRuleSet,
  updateRoleFloatDetails,
} from 'modules/Roles/actions'
import selector from 'modules/Roles/selectors'
import { connect } from 'react-redux'
import {
  rejectStudentStatus,
  studentOptedStatus,
  updateOptedStatus,
  updateOptedWitdrawStatus,
} from '../actions'
import selectors from '../selectors'
import { getCities } from 'modules/Resume/actions'

const mapStateToProps = state => ({
  rolesList: selector.getRolesList(state),
  dashboardMetric: selectorARM.getAppliedRoleMetrics(state),
  studentDetails: selector2.getStudentDetails(state),
  studentData: selector2.getStudentEditData(state),
  drivesList: selectorDrive.getDrivesList(state),
  collegeData: selector2.getCampuDetails(state),
  studentDetail: selector2.getStudentResumeData(state),
  functionsList: selector2.getFunctionsList(state),
  optoutStatus: selectors.getOptOutStatus(state),
  countryList: selector2.getCountryList(state),
  stateList: selector2.getStateList(state),
})

const mapDispatchToProps = {
  ApplyRole,
  SaveRole,
  getRolesList,
  getSingleRoleDetails,
  getAppliedRoleMetrics,
  getStudentData,
  getDrivesList,
  getRoleFloatDetails,
  getEligibleDetails,
  getFunctionsList,
  updateRoleFloatDetails,
  updateStudentData,
  getListOfSkills,
  updateStudent,
  getStudentRoleList,
  getCompTypeList,
  getStudentRuleSet,
  studentOptedStatus,
  updateOptedStatus,
  updateOptedWitdrawStatus,
  rejectStudentStatus,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  searchAPI,
  updateCvDetails,
  deleteEducation,
  getCities,
  updateCurrentState,
  updateStatusPending,
  updateUserProfile,
  getDesignationsList
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
